<template>
  <div>
    <div class="container" id="transformationFilesView-container">
      <h5 class="mt-4 mb-4">{{ 'TRANSFORMATION_FILES' | translate('nav') }}</h5>
      <div class="form-row" id="transformationFilesView-row">
        <label for="import_type" class="col-auto col-lg-1 col-form-label">{{ 'PRODUCT_LINE' | translate }}</label>
        <div class="col-auto" id="transformationFilesView-col">
          <select class="form-control"
                  v-model="selectedProductLine"
                  name="product_line"
                  id="import_type"
                  required>
            <option v-for="productLine in enabledProductLines" :value="productLine" :id="'transformationFilesView-' + productLine.description">
              {{ productLine.description }}
            </option>
          </select>
        </div>
        <div class="col-auto" id="transformationFilesView-buttonDiv">
          <button type="button"
                  class="btn btn-link"
                  v-if="selectedProductLine"
                  v-on:click="getSelectedProductLineTransformationFile(selectedProductLine)"
                  id="transformationFilesView-downloadButton"
          >{{ 'DOWNLOAD' | translate }}</button>
        </div>
      </div>
      <div class="alert alert-warning alert-dismissible mt-5" v-if="warningMessage">
        {{ warningMessage }}
        <button type="button" class="close" @click="dismissAlertWarning()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <hr class="mt-4 mb-4">
      <div class="row" id="transformationFilesView-uploadRow">
        <div class="col-5" id="transformationFilesView-uploadCol">
          <form v-on:submit.prevent="submitForm()" id="transformationFilesView-Submitform">
            <div class="form-group" id="transformationFilesView-submitFormGroup">
              <label for="import_file" class="mb-4" id="transformationFilesView-formGroupLabel">
                {{ 'UPLOAD_TRANSFORMATION_FILE' | translate }} ({{ selectedProductLine.description }}):
              </label>
              <div class="form-row" id="transformationFilesView-formRow">
                <div class="col-8" id="transformationFilesView-formRow-col">
                  <div class="custom-file" id="transformationFilesView-customFile">
                    <input type="file" class="custom-file-input" id="import_file" name="import_file"
                           v-on:change="selectFile" required>
                    <label class="custom-file-label" for="import_file" id="transformationFilesView-customFile-label">
                      {{ (file && file.name) ? file.name : 'UPLOAD_FILE' | translate }}
                    </label>
                  </div>
                </div>
                <div class="col" id="transformationFilesView-formCol">
                  <button type="submit" class="btn btn-primary" v-if="!submitting" id="transformationFilesView-submitButton">{{ 'SUBMIT' | translate }}</button>
                  <img src="/static/loader-tail.svg" width="30" v-else>
                </div>
              </div>
            </div>
          </form>
          <div class="alert alert-success alert-dismissible mt-5" v-if="successMessage">
            {{ successMessage }}
            <button type="button" class="close" @click="dismissAlertSuccess()" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="alert alert-danger alert-dismissible mt-5" v-if="errorMessage" >
            {{ errorMessage }}
            <button type="button" class="close" @click="dismissAlertError()" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
    </div>
      </div>
    </div>
  </div>
</template>
<script>
    import RestService from '../../service/RestService.js';
    import GeneralConfigService from '../../service/GeneralConfigService';

    export default {
      components: {
      },
      data: function () {
        return {
          rest: this.initRestService(),
          selectedProductLine: '',
          enabledProductLines: [],
          submitting: false,
          file: null,
          successMessage: null,
          errorMessage: null,
          warningMessage: null
        }
      },
      async beforeMount() {
        await this.init();
      },
      methods: {
        initRestService() {
          return new RestService();
        },
        async init() {
          this.enabledProductLines = await GeneralConfigService.getEnabledProductLines();
          this.selectedProductLine = this.enabledProductLines[0];
        },
        selectFile: function (evt) {
          this.file = evt.target.files[0];
        },
        submitForm: function () {
          this.submitting = true;
          const formData = new FormData();

          formData.append('productLineName', this.selectedProductLine.name);
          formData.append('transformation_file', this.file);
          formData.append('file_name', this.file.name);

          const vm = this;
          this.rest.postToServer('/export/transformation-file', formData)
            .then((response) => {
              vm.submitting = false;
              setTimeout(() => {
                vm.cmLoaded = true;
                vm.setSuccessMessage(this.$options.filters.translate('TRANSFORMATION_FILE_UPLOAD_SUCCESS', 'msg'));
              }, 300);
            }).catch((err) => {
              if (typeof err.response !== 'undefined') {
                this.$log.error(err.response.data);
              } else {
                this.$log.error(err);
              }
              vm.submitting = false;
              vm.setErrorMessage(this.$options.filters.translate('CANT_UPLOAD_FILE', 'msg') + '\n' + err.response.data);
            });
        },
        getSelectedProductLineTransformationFile: function(productLine) {
          const vm = this;
          this.rest.getTransformationFile(productLine.name).then((response) => {
            if (response.status === 204) {
              setTimeout(() => {
                vm.setWarningMessage(this.$options.filters.translate('MISSING_TRANSFORMATION_FILE', 'msg') +
                  ' ' + this.$options.filters.translate(productLine.name, 'product'));
              }, 300);
            } else {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', `${productLine.name}.ktr`);
              link.click();
              window.URL.revokeObjectURL(url);
            }
          });
        },
        setSuccessMessage: function(message) {
          this.successMessage = message;
          const vm = this;
          setTimeout(function() {
            vm.dismissAlertSuccess();
          }, 3000);
        },
        setErrorMessage: function(message) {
          this.errorMessage = message;
        },
        setWarningMessage: function(message) {
          this.warningMessage = message;
          const vm = this;
          setTimeout(function() {
            vm.dismissAlertWarning();
          }, 3000);
        },
        dismissAlertSuccess: function() {
          this.successMessage = null;
        },
        dismissAlertError: function() {
          this.errorMessage = null;
        },
        dismissAlertWarning: function() {
          this.warningMessage = null;
        }
      }
    }
</script>



// WEBPACK FOOTER //
// src/components/admin/TransformationFilesView.vue